import PropTypes from 'prop-types';
import React from 'react';
// import ReactModal from 'react-modal';
import Draggable from 'react-draggable'
import bindAll from 'lodash.bindall';
import { connect } from 'react-redux';
import { sendChartData } from '../../reducers/code';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import tabStyles from 'react-tabs/style/react-tabs.css';
import styles from './modal.css';
import classNames from 'classnames';
import ModalChart from './modalCharts.jsx';
import Empty from './empty.png'


const tabClassNames = {
    tabs: styles.tabs,
    tab: classNames(tabStyles.reactTabsTab, styles.tab),
    tabList: classNames(tabStyles.reactTabsTabList, styles.tabList),
    tabPanel: classNames(tabStyles.reactTabsTabPanel, styles.tabPanel),
    tabPanelSelected: classNames(tabStyles.reactTabsTabPanelSelected, styles.isSelected),
    tabSelected: classNames(tabStyles.reactTabsTabSelected, styles.isSelected)
};


class ModalComponent extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleDataVisualization',
            'closeModal',
            'handleChange',
            'handleModalSizeChange'
        ]);
        this.state = {
            tableData: [],
            activeTabIndex: 0,
            blockData: {
                openChartWindow: false,
                setChartTitle: '未命名',
                setChartType: 'table',
                setRenderSpeed: 'no_delay',
                setAxisTitle: {},
                setRightYTitle: '右y轴',
                setDataGroup: {},
                inputVariables: {},
                inputVariablesTerm: {}
            },
            type: 'line',
            isLarge: false
        };
    }
    //数据处理
    componentWillReceiveProps(nextProps) {
        this.handleDataVisualization(nextProps.chartData);
    }
    //积木块事件处理
    handleDataVisualization(data) {
        let { blockData, tableData } = this.state;
        switch (data.type) {
            case 'setChartTitle':
                blockData.setChartTitle = data.args.title;
                break;
            case 'setChartType':
                blockData.setChartType = data.args.chartType;
                this.state.type = data.args.chartType;
                this.state.activeTabIndex = data.args.chartType == 'table' ? 0 : 1;
                break;
            case 'setRenderSpeed':
                blockData.setRenderSpeed = data.args.renderSpeed;
                break;
            case 'setAxisTitle':
                blockData.setAxisTitle.xAxisTitle = data.args.axisX; //x轴标题
                blockData.setAxisTitle.yAxisTitle = data.args.axisY; //y左轴标题
                break;
            case 'setRightYTitle':
                blockData.setRightYTitle = data.args.rightYTitle; //y右轴标题
                break;
            case 'setDataGroup':
                let _rightY = data.args.rightY;
                //该组存在 覆盖
                if (blockData.setDataGroup[_rightY]) {
                    blockData.setDataGroup[_rightY].name = _rightY;
                    blockData.setDataGroup[_rightY].value = data.args.axis; //默认左y轴 值为：left_y 
                } else {
                    //创建新组
                    blockData.setDataGroup[_rightY] = {};
                    blockData.setDataGroup[_rightY].name = _rightY || '';
                    blockData.setDataGroup[_rightY].value = data.args.axis;
                }
                break;
            case 'inputVariables':
                const { variablesData = '', variablesX = '', variablesY = '' } = data.args;
                //组存在
                if (variablesData in blockData.inputVariables) {
                    //x轴名称存在 直接更新值
                    const xAxisName = blockData.inputVariables[variablesData].xAxisName;
                    if (xAxisName.includes(variablesX)) {
                        const idx = xAxisName.indexOf(variablesX);
                        blockData.inputVariables[variablesData].yAxisData[idx] = variablesY;
                    } else {
                        //x轴不存在 创建x轴
                        blockData.inputVariables[variablesData].xAxisName.push(variablesX);
                        blockData.inputVariables[variablesData].yAxisData.push(variablesY);
                    }
                } else {
                    // 创建组 init 
                    blockData.inputVariables[variablesData] = {};
                    blockData.inputVariables[variablesData].xAxisName = []; //x轴 名称
                    blockData.inputVariables[variablesData].yAxisData = []; //y轴 值
                    //赋值
                    blockData.inputVariables[variablesData].name = variablesData;
                    blockData.inputVariables[variablesData].xAxisName.push(variablesX);
                    blockData.inputVariables[variablesData].yAxisData.push(variablesY);
                    //更新setDataGroup的值
                    let _setDataGroup = blockData.setDataGroup || {};
                    if (!(variablesData in _setDataGroup)) {
                        blockData.setDataGroup[variablesData] = {};
                        blockData.setDataGroup[variablesData].name = variablesData;
                        blockData.setDataGroup[variablesData].value = 'left_y';
                    }
                }
                break;
            case 'clearChart':
                blockData = {
                    openChartWindow: false,
                    setChartTitle: '未命名',
                    setChartType: this.state.type,
                    setRenderSpeed: 'no_delay',
                    setAxisTitle: {},
                    setRightYTitle: '右y轴',
                    setDataGroup: {},
                    inputVariables: {},
                    inputVariablesTerm: {}
                }
                break;
            default:
        }
        //定义表格空数据
        tableData = {
            thead: [], //标题
            tbody: [] //数据
        };
        //设置表格第一列的标题 如果没有设置默认为type(前提是x轴或y轴有数据)
        if (blockData.setAxisTitle && blockData.setAxisTitle.xAxisTitle) {
            tableData.thead.push(blockData.setAxisTitle.xAxisTitle)
        } else if (Object.keys(blockData.inputVariables).length > 0 || Object.keys(blockData.inputVariablesTerm).length > 0) {
            tableData.thead.push('type'); //x轴没有数据时 设定为type
        }
        if (Object.keys(blockData.inputVariables).length > 0) {
            const xAxisNames = []
            for (let i in blockData.inputVariables) {
                tableData.thead.push(i) //数据组
                let xAxisName = blockData.inputVariables[i].xAxisName;
                if (xAxisName && xAxisName.length > 0) {
                    for (let ii of xAxisName) {
                        if (!xAxisNames.includes(ii)) {
                            xAxisNames.push(ii);
                        }
                    }
                }
            }
            //初始化tbody
            xAxisNames.forEach((item, index) => {
                tableData.tbody[index] = Array(tableData.thead.length).fill('');
                tableData.tbody[index][0] = item; //数组的第一项 x轴名称
            })
            //给tbody设值
            tableData.thead.forEach((item, index) => {
                if (index > 0) {
                    for (let k in blockData.inputVariables) {
                        //匹配
                        if (item === k) {
                            //取值
                            let xAxisName = blockData.inputVariables[k].xAxisName;
                            let yAxisData = blockData.inputVariables[k].yAxisData || [];
                            if (xAxisName && xAxisName.length > 0) {
                                for (let kk of xAxisName) {
                                    let idx = xAxisNames.indexOf(kk);
                                    let _idx = xAxisName.indexOf(kk);
                                    tableData.tbody[idx][index] = yAxisData[_idx] || '';
                                }
                            }
                        }
                    }
                }
            })
        }
        //console.log('blockData==>', blockData, "===tableData====>", this.state.tableData, "tableData", tableData);
        this.setState({
            blockData,
            tableData
        })
    }
    onActivateTab(e) {
        this.setState({
            activeTabIndex: e
        })
    }
    onStart(e) {
    };
    handleDrag(e) {
    };
    onStop() {
    };
    //下拉选框切换
    handleChange(e) {
        this.setState({
            blockData: Object.assign({}, this.state.blockData, {
                setChartType: e.target.value
            }),
            type: e.target.value
        })
    }
    //缩放功能
    handleModalSizeChange() {
        this.setState({
            isLarge: !this.state.isLarge
        })
    }
    closeModal() {
        this.props.onRequestClose();
    }
    handleStart() { }
    handleStop() { }
    render() {
        const { activeTabIndex, tableData, blockData, isLarge } = this.state;
        return (
            <div className="draggable_box">
                <Draggable
                    onStart={this.handleStart}
                    onDrag={this.handleDrag}
                    onStop={this.handleStop} >
                    <div className={styles.modalChart} style={{ width: isLarge ? 1000 : 620, height: isLarge ? 600 : 500, marginLeft: isLarge ? -500 : -310 }}>
                        {isLarge ? <i className={styles.modalEnlarge} onClick={this.handleModalSizeChange}></i> : <i className={styles.modalDefault} onClick={this.handleModalSizeChange}></i>}
                        <span className={styles.closeModal} onClick={this.closeModal}>×</span>
                        <Tabs
                            forceRenderTabPanel
                            className={tabClassNames.tabs}
                            selectedIndex={activeTabIndex}
                            selectedTabClassName={tabClassNames.tabSelected}
                            selectedTabPanelClassName={tabClassNames.tabPanelSelected}
                            onSelect={(e) => this.onActivateTab(e)}>
                            <TabList className={tabClassNames.tabList}>
                                <Tab className={tabClassNames.tab} style={{ fontSize: '14px' }}>数据表格</Tab>
                                <Tab className={tabClassNames.tab} style={{ fontSize: '14px' }}>可视化图表</Tab>
                            </TabList>
                            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                <h4 className={styles.chartTitle}>{blockData.setChartTitle}</h4>
                                {
                                    this.state.activeTabIndex == 1 ? <select className={styles.select}
                                        value={this.state.type} onChange={this.handleChange}>
                                        <option value='line'>折线图</option>
                                        <option value='histogram'>柱状图</option>
                                        <option value='biaxial'>双轴图</option>
                                        <option value='pie'>饼图</option>
                                    </select> : null
                                }
                            </div>
                            <TabPanel className={tabClassNames.tabPanel}>
                                {
                                    tableData && tableData.thead && tableData.thead.length > 0 ?
                                        <table className={styles.chart_table} border='1px'>
                                            <thead className={styles.table_head}>
                                                <tr>
                                                    {tableData.thead.map((v, i) => {
                                                        return <th key={i}>{v}</th>
                                                    })}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tableData.tbody.map((v, i) => {
                                                    return <tr key={i}>{v.map((j, k) => {
                                                        return <td key={k}>{j}</td>
                                                    })}</tr>
                                                })}
                                            </tbody>
                                        </table> :
                                        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                            <img style={{ width: 180, marginTop: 20 }} src={Empty} alt="暂无数据" />
                                            <p style={{ fontSize: '14px', lineHeight: 2, color: '#666' }}>暂无数据</p>
                                        </div>
                                }
                            </TabPanel>
                            <TabPanel className={tabClassNames.tabPanel}>
                                <ModalChart blockData={blockData} tableData={tableData} isLarge={isLarge} />
                            </TabPanel>
                        </Tabs>
                    </div>
                </Draggable>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    chartData: state.scratchGui.code.chartData,
    count: state.scratchGui.code.count,
});

const mapDispatchToProps = dispatch => ({
    sendChartData: (block) => {
        dispatch(sendChartData(block))
    }
});

export default connect(
    mapStateToProps,
    // mapDispatchToProps
    mapDispatchToProps
)(ModalComponent);

